module.exports = __webpack_public_path__ + "media/112.e7ef11d9.wav";